import type { PropsWithChildren } from "react";

import type { PenaltyClock } from "src/types/matchControl/clock";
import type { Contestant } from "src/types/matchControl/contestant";

import PenaltyClocks from "./PenaltyClocks";

type PenaltyClockSectionProps = PropsWithChildren & {
	home: Contestant;
	away: Contestant;
	handleCreateClock: (type: PenaltyClock["type"], contestantId: string) => void;
	handleDeleteClock: (id: string) => void;
};

const PenaltyClockSection = ({
	home,
	away,
	handleCreateClock,
	handleDeleteClock,
}: PenaltyClockSectionProps) => {
	if (!("clocks" in home) || !("clocks" in away)) {
		return null; // Ensure that both contestants have penalty clocks
	}

	const homePenaltyClocks = home.clocks ?? [];
	const awayPenaltyClocks = away.clocks ?? [];

	return (
		<div className="w-full flex flex-col gap-2">
			<div className="grid grid-cols-2 gap-8 w-full">
				<PenaltyClocks
					title={home.name}
					handleCreateClock={() => handleCreateClock("penaltyclock", home.id)}
					handleDeleteClock={handleDeleteClock}
					penaltyClocks={homePenaltyClocks}
				/>
				<PenaltyClocks
					title={away.name}
					handleCreateClock={() => handleCreateClock("penaltyclock", away.id)}
					handleDeleteClock={handleDeleteClock}
					penaltyClocks={awayPenaltyClocks}
				/>
			</div>
		</div>
	);
};

export default PenaltyClockSection;
